import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import { fetchProducts } from './feedback-products.utils';
import { createFrozenMap } from '@/vuex/utils';

const SET_ERROR = 'setError';
const SET_FETCHING = 'setFetching';
const SET_MAP = 'setMap';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        [SET_MAP] (state, { map }) {
            state.map = map;
        },
        [SET_ERROR] (state, { error }) {
            state.error = error;
        },
        [SET_FETCHING] (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false }) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            commit(SET_FETCHING, { fetching: true });
            try {
                const { data: products } = await fetchProducts();
                commit(SET_MAP, {
                    map: createFrozenMap(products, 'uuid'),
                });
            } catch (fetchingError) {
                commit(SET_ERROR, { error: fetchingError });
                throw fetchingError;
            }
            commit(SET_FETCHING, { fetching: false });
        },
    },
    getters: {
        list: (state) => values(state.map),
        productById: (state) => (id) => state.map[id],
    },
};
